module.exports = __webpack_public_path__ + "media/images/cms/logo_brand_01-af10dd32b7a9436ebdeb28e2b246e0bc.png";